<template>
  <div class="col-sm-12 col-md">
    <abstract-profile-text-input
      id="input-document-issue-date"
      type="date"
      v-model="model"
      :error="errors"
      :label="computedLabel"
      :placeholder="computedPlaceholder"
      @change="inputChange"
      @input="onInput"
      :rules="required ? 'required' : ''"
      :disabled="disabled"
    />
  </div>
</template>

<script>
import AbstractProfileTextInput from "../core/AbstractProfileTextInput";
import BaseInputMixin from "../../../../mixins/profileInputMixin";

export default {
  name: "DocumentIssueDate",
  components: {AbstractProfileTextInput},
  mixins: [BaseInputMixin('document_issue_date', 'identityVerification', 'identityVerificationFieldOnInput')],

  data() {
    return {
      defaultLabel: this.$t("Document Issue Date")
    }
  },
}
</script>

<style scoped>

</style>
